import jsonata from "jsonata";
//#region src/evaluate.ts
const compiled = /* @__PURE__ */ new Map();
const message = (error) => {
	return `JSONata evaluation error: ${error && typeof error === "object" && "message" in error ? String(error.message) : String(error)}`;
};
/** Compile an expression, memoised. A malformed one warns once, not per evaluation. */
function compilePath(path) {
	const hit = compiled.get(path);
	if (hit) return hit;
	let result;
	try {
		result = { expression: jsonata(path) };
	} catch (error) {
		console.warn(`Error parsing data path '${path}':`, error);
		result = { error: message(error) };
	}
	compiled.set(path, result);
	return result;
}
/** `error` is set only when jsonata refused or threw; a path matching nothing is null. */
async function evaluate(path, data, bindings) {
	const result = compilePath(path);
	if ("error" in result) return {
		value: null,
		error: result.error
	};
	try {
		return { value: await result.expression.evaluate(data, bindings) ?? null };
	} catch (error) {
		console.warn(`Error evaluating data path '${path}':`, error);
		return {
			value: null,
			error: message(error)
		};
	}
}
//#endregion
//#region src/binding.ts
/** A blank path is an unfinished binding, not an expression to parse. */
const resolveBinding = async (path, data, bindings) => path ? evaluate(path, data, bindings) : {
	value: null,
	error: "Binding path is empty"
};
/** Only the value can say a path fanned out: jsonata flattens a one-item sequence. */
const rowsOf = (value) => Array.isArray(value) ? { rows: value } : {
	rows: [],
	error: "Binding did not resolve to a list"
};
//#endregion
export { evaluate, resolveBinding, rowsOf };

//# sourceMappingURL=index.js.map